// Validación y normalización de RUT chileno (formato + dígito verificador, módulo 11).
// Portado del sistema de máscara de las landings (lib/rut.ts) para reutilizar el mismo
// comportamiento en el checkout de Caja Los Andes.

export function normalizeRut(input: string): string {
  return (input || '').replace(/[.\-\s]/g, '').toUpperCase();
}

export function isValidRut(input: string): boolean {
  const r = normalizeRut(input);
  if (!/^\d{7,8}[0-9K]$/.test(r)) return false;
  const body = r.slice(0, -1);
  const dv = r.slice(-1);
  let sum = 0;
  let mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const res = 11 - (sum % 11);
  const expected = res === 11 ? '0' : res === 10 ? 'K' : String(res);
  return dv === expected;
}

// Formato visual 12.345.678-9 (solo presentación).
export function formatRut(input: string): string {
  const r = normalizeRut(input);
  if (r.length < 2) return r;
  const body = r.slice(0, -1);
  const dv = r.slice(-1);
  return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv}`;
}
